import i18n.LocaleManager

/**
 * The inner markup of the header's language control: a globe, then the language
 * currently in effect.
 *
 * The bare code ("EN", "FR") read as a status badge rather than as a control,
 * and a two-language app offers no other clue — so "EN" got taken as "click for
 * English" when it meant "you are in English", and clicking it switched the app
 * to French. That misread is the whole reason the language appeared to be
 * getting lost.
 *
 * The globe is what marks the element as the language control; the code stays
 * the CURRENT language, which is the common pattern once an icon carries the
 * affordance (Stripe, Airbnb, Apple all read this way). The alternative
 * convention — naming the language you would switch TO, as bilingual Canadian
 * sites do — needs the language's own name ("Français") to be unambiguous, and
 * there is no room for that in these headers.
 *
 * Inline SVG rather than the 🌐 emoji so the glyph inherits `currentColor` and
 * picks up whatever accent each header is using.
 */
fun languageToggleLabel(): String =
    """<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" style="vertical-align: -2px; margin-right: 3px;"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18z"/></svg>${LocaleManager.getCurrentLocale().flag}"""
